export default "__VITE_ASSET__Hem_DvPs__"